/**
 * @description 系统设置 systemSetting
 * @author 系统生成
 * @date 2018/9/20
 */

import Logic from '../logic-base'
import ExportTable from '@/utils/exportTable'

const systemSettingBiz = new Logic()

systemSettingBiz.getAccident = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.getAccident,
    data: data
  })
}

systemSettingBiz.deleteAccident = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.deleteAccident,
    data: data
  })
}

systemSettingBiz.changeAccident = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.changeAccident,
    data: data
  })
}

systemSettingBiz.addAccident = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.addAccident,
    data: data
  })
}

systemSettingBiz.getAccidentById = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.getAccidentById,
    data: data
  })
}

systemSettingBiz.getRelease = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.getRelease,
    data: data
  })
}

systemSettingBiz.deleteRelease = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.deleteRelease,
    data: data
  })
}

systemSettingBiz.changeRelease = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.changeRelease,
    data: data
  })
}

systemSettingBiz.addRelease = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.addRelease,
    data: data
  })
}

systemSettingBiz.getKpi = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.getKpi,
    data: data
  })
}

systemSettingBiz.deleteKpi = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.deleteKpi,
    data: data
  })
}

systemSettingBiz.changeKpi = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.changeKpi,
    data: data
  })
}

systemSettingBiz.addKpi = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.addKpi,
    data: data
  })
}

systemSettingBiz.getStrategy = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.getStrategy,
    data: data
  })
}

systemSettingBiz.deleteStrategy = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.deleteStrategy,
    data: data
  })
}

systemSettingBiz.changeStrategy = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.changeStrategy,
    data: data
  })
}

systemSettingBiz.addStrategy = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.addStrategy,
    data: data
  })
}

systemSettingBiz.findStrategyId = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.findStrategyId,
    data: data
  })
}

systemSettingBiz.getIP = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.getIP,
    data: data
  })
}

systemSettingBiz.getAgent = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.getAgent,
    data: data
  })
}

systemSettingBiz.deleteAgent = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.deleteAgent,
    data: data
  })
}

systemSettingBiz.configAgent = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.configAgent,
    data: data
  })
}

systemSettingBiz.saveConfigAgent = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.saveConfigAgent,
    data: data
  })
}

systemSettingBiz.excuteInstall = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.excuteInstall,
    data: data
  })
}

systemSettingBiz.queryAgent = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.queryAgent,
    data: data
  })
}

systemSettingBiz.getSubscribe = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.getSubscribe,
    data: data
  })
}

systemSettingBiz.getGroup = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.getGroup,
    data: data
  })
}

systemSettingBiz.addSubscribe = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.addSubscribe,
    data: data
  })
}

systemSettingBiz.getAlarmList = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.getAlarmList,
    data: data
  })
}

systemSettingBiz.saveSubscribe = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.saveSubscribe,
    data: data
  })
}

systemSettingBiz.deleteSubscribe = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.deleteSubscribe,
    data: data
  })
}

systemSettingBiz.addGroup = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.addGroup,
    data: data
  })
}

systemSettingBiz.addUserInfo = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.addUserInfo,
    data: data
  })
}

systemSettingBiz.deleteGroups = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.deleteGroups,
    data: data
  })
}

systemSettingBiz.addLog = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.addLog,
    data: data
  })
}

systemSettingBiz.deleteLog = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.deleteLog,
    data: data
  })
}

systemSettingBiz.getLog = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.getLog,
    data: data
  })
}

systemSettingBiz.changeLog = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.changeLog,
    data: data
  })
}

systemSettingBiz.addRoute = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.addRoute,
    data: data
  })
}

systemSettingBiz.deleteRoute = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.deleteRoute,
    data: data
  })
}

systemSettingBiz.getRoute = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.getRoute,
    data: data
  })
}

systemSettingBiz.changeRoute = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.changeRoute,
    data: data
  })
}

systemSettingBiz.getTopic = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.getTopic,
    data: data
  })
}

systemSettingBiz.cloneKpi = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.cloneKpi,
    data: data
  })
}

systemSettingBiz.cloneIP = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.cloneIP,
    data: data
  })
}

systemSettingBiz.queryFieldRouteConfig = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.queryFieldRouteConfig,
    data: data
  })
}

systemSettingBiz.updateFieldRouteConfig = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.updateFieldRouteConfig,
    data: data
  })
}

systemSettingBiz.addFieldRouteConfig = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.addFieldRouteConfig,
    data: data
  })
}

systemSettingBiz.deleteFieldRouteConfig = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.systemSetting.deleteFieldRouteConfig,
    data: data
  })
}

/**
 * Created by libaiqi on 2019/01/18.
 * 版本发布录入导出
 * @param fields 表头信息{name: text,...}
 * @param time  时间需要转换的表头
 * @param staticDictionary 静态字典
 */
systemSettingBiz.exportVersion = function (fields, search, time, staticDictionary, success, fail) {
  const exportTable = new ExportTable({
    requestData: this.REQUEST_OPT.systemSetting.getRelease,
    fields: fields,
    search: search,
    time: time,
    staticDictionary: staticDictionary,
    isJson: 1
  })
  exportTable.send(success, fail)
}

/**
 * Created by libaiqi on 2019/02/22.
 * 网上事故录入导出
 * @param fields 表头信息{name: text,...}
 * @param time  时间需要转换的表头
 * @param staticDictionary 静态字典
 */
systemSettingBiz.exportAccident = function (fields, search, time, showtime, staticDictionary, success, fail) {
  const exportTable = new ExportTable({
    requestData: this.REQUEST_OPT.systemSetting.getAccident,
    fields: fields,
    search: search,
    time: time,
    showtime: showtime,
    staticDictionary: staticDictionary,
    isJson: 1
  })
  exportTable.send(success, fail)
}
export default systemSettingBiz
